(function (global) {
  'use strict';

  var LINE_SELECTOR = '[data-tf-cart-multibuy-line]';
  var DISCLOSURE_SELECTOR = '[data-tf-bundle-disclosure]';
  var ALLOCATION_SELECTOR = '[data-tf-cart-discount-allocation]';
  var STATUS_SELECTOR = '[data-tf-cart-multibuy-status]';
  var PREORDER_HELP_SELECTOR = '[data-tf-preorder-help]';

  function positiveWholeNumber(value) {
    return /^[1-9]\d*$/.test(value || '') ? Number(value) : null;
  }

  function nonNegativeWholeNumber(value) {
    return /^\d+$/.test(value || '') ? Number(value) : null;
  }

  function qualifyingPieceQuantity(lines) {
    var total = 0;
    for (var index = 0; index < lines.length; index += 1) {
      var line = lines[index];
      if (line.getAttribute('data-counts-toward-threshold') !== 'true') continue;
      var quantity = positiveWholeNumber(line.getAttribute('data-cart-quantity'));
      var pieces = positiveWholeNumber(line.getAttribute('data-physical-piece-count'));
      if (quantity === null || pieces === null || quantity > Number.MAX_SAFE_INTEGER / pieces) return null;
      total += quantity * pieces;
      if (!Number.isSafeInteger(total)) return null;
    }
    return total;
  }

  function displayPieceLabel(policy, currentTier, quantity) {
    var tiers = policy && policy.tiers;
    if (!Array.isArray(tiers) || !currentTier) return null;
    for (var index = 0; index < tiers.length; index += 1) {
      var tier = tiers[index];
      if (tier.minimumQuantity !== currentTier.minimumQuantity || tier.percentage !== currentTier.percentage) continue;
      return index === tiers.length - 1 ? String(tier.minimumQuantity) + '+' : String(quantity);
    }
    return null;
  }

  function cartSurfaceFor(element) {
    return element && element.closest ? element.closest('cart-drawer, .shopify-section--main-cart') : null;
  }

  function cartPresentation(api, surface) {
    var contract = api.readCartContract();
    var quantity = qualifyingPieceQuantity(surface ? surface.querySelectorAll(LINE_SELECTOR) : []);
    var progress;
    if (!contract || quantity === null) return null;
    progress = api.resolveProgress(contract.policy, quantity);
    if (!progress || progress.state !== 'active') return null;
    return { contract: contract, quantity: quantity, progress: progress };
  }

  function matchedAllocationAmountCents(allocations, api, percentage) {
    var total = 0;
    var matched = false;
    for (var index = 0; index < allocations.length; index += 1) {
      var allocation = allocations[index];
      var amount = nonNegativeWholeNumber(allocation.getAttribute('data-discount-amount-cents'));
      if (amount === null || !api.isCartAllocation(allocation.getAttribute('data-discount-title'), percentage)) continue;
      total += amount;
      if (!Number.isSafeInteger(total)) return null;
      matched = true;
    }
    return matched ? total : null;
  }

  function formatCartCurrency(cents, status) {
    var currency = status && status.getAttribute && status.getAttribute('data-tf-cart-currency');
    var locale = status && status.getAttribute && status.getAttribute('data-tf-cart-locale');
    if (!Number.isSafeInteger(cents) || cents < 0 || !currency || !global.Intl || !global.Intl.NumberFormat) return '';
    try {
      return new global.Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (error) {
      return '';
    }
  }

  function pluralizedPiece(count) {
    return count === 1 ? 'piece' : 'pieces';
  }

  function setStatusCopy(status, selector, copy) {
    var element = status.querySelector(selector);
    if (!element) return;
    element.textContent = copy || '';
    element.hidden = !copy;
  }

  function resetNextStatus(status) {
    var next = status.querySelector('[data-tf-cart-multibuy-next]');
    var remaining = status.querySelector('[data-tf-cart-multibuy-next-remaining]');
    var suffix = status.querySelector('[data-tf-cart-multibuy-next-suffix]');
    if (!next || !remaining || !suffix) return;
    remaining.textContent = '';
    suffix.textContent = '';
    next.hidden = true;
  }

  function setEarnedStatus(status, copy) {
    var current = status.querySelector('[data-tf-cart-multibuy-current]');
    var earned = status.querySelector('[data-tf-cart-multibuy-earned]');
    if (!current || !earned) return;
    earned.textContent = copy || '';
    current.hidden = !copy;
  }

  function setNextStatus(status, remaining, percentage, hasEarnedTier) {
    var next = status.querySelector('[data-tf-cart-multibuy-next]');
    var remainingElement = status.querySelector('[data-tf-cart-multibuy-next-remaining]');
    var suffix = status.querySelector('[data-tf-cart-multibuy-next-suffix]');
    var phrase;
    if (!next || !remainingElement || !suffix || !Number.isInteger(remaining) || remaining <= 0 || percentage === undefined) return;
    phrase = remaining + ' more ' + (hasEarnedTier ? '' : 'jewelry ') + pluralizedPiece(remaining);
    remainingElement.textContent = phrase;
    suffix.textContent = hasEarnedTier ? ' to unlock ' + percentage + '% off' : ' for ' + percentage + '% off';
    next.hidden = false;
  }

  function enhanceCartStatus(api, status, presentation, allocations) {
    var currentTier;
    var nextTier = presentation && presentation.progress.nextTier;
    var remaining = presentation && presentation.progress.piecesRemainingToNextTier;
    if (!presentation) {
      status.hidden = true;
      return;
    }
    currentTier = presentation.progress.currentTier;
    nextTier = presentation.progress.nextTier;
    remaining = presentation.progress.piecesRemainingToNextTier;
    var savings = currentTier ? matchedAllocationAmountCents(allocations, api, currentTier.percentage) : null;
    var savingsCopy = savings === null ? '' : formatCartCurrency(savings, status);
    var earnedCopy = currentTier && savings > 0 && savingsCopy ? presentation.quantity + ' jewelry ' + pluralizedPiece(presentation.quantity) + ' · ' + currentTier.percentage + '% off · You save ' + savingsCopy : '';
    if (!earnedCopy && (!nextTier || !Number.isInteger(remaining) || remaining <= 0)) {
      status.hidden = true;
      return;
    }
    status.hidden = false;
    setEarnedStatus(status, earnedCopy);
    if (nextTier && Number.isInteger(remaining) && remaining > 0) {
      setNextStatus(status, remaining, nextTier.percentage, Boolean(currentTier));
    } else {
      resetNextStatus(status);
    }
  }

  function enhanceMultibuy() {
    var api = global.TheFaithMultibuy;
    var statuses;

    if (!api || typeof api.readCartContract !== 'function' || typeof api.resolveProgress !== 'function' || typeof api.isCartAllocation !== 'function' || !global.document) return;
    statuses = global.document.querySelectorAll(STATUS_SELECTOR);
    for (var index = 0; index < statuses.length; index += 1) {
      var status = statuses[index];
      var surface = cartSurfaceFor(status);
      var allocations = surface ? surface.querySelectorAll(ALLOCATION_SELECTOR) : [];
      enhanceCartStatus(api, status, cartPresentation(api, surface), allocations);
    }
  }

  function toggleBundleDisclosure(button) {
    var id = button.getAttribute('aria-controls');
    var surface = cartSurfaceFor(button);
    var panel = id && surface && surface.querySelector('[id="' + id + '"]');
    var expanded;
    if (!panel) return;
    expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    panel.hidden = expanded;
  }

  function preorderHelpParts(notice) {
    var button = notice && notice.querySelector && notice.querySelector('.cart-preorder-notice__help');
    var panelId = button && button.getAttribute('aria-controls');
    var panel = panelId && global.document && global.document.getElementById(panelId);
    return { button: button, panel: panel };
  }

  function isPreorderHelpOpen(notice) {
    var parts = preorderHelpParts(notice);
    return Boolean(parts.panel && !parts.panel.hidden);
  }

  function placePreorderHelp(notice, panel) {
    var viewportWidth;
    var popupWidth;
    if (!notice || !panel || !panel.style) return;
    viewportWidth = global.innerWidth || (global.document && global.document.documentElement && global.document.documentElement.clientWidth) || 0;
    popupWidth = viewportWidth <= 699 ? Math.max(0, viewportWidth - 32) : Math.min(320, Math.max(0, viewportWidth - 32));
    panel.style.bottom = 'calc(100% + 8px)';
    panel.style.width = popupWidth + 'px';
    panel.style.top = 'auto';
    panel.style.left = '0';
  }

  function setPreorderHelpOpen(notice, open) {
    var parts = preorderHelpParts(notice);
    if (!parts.button || !parts.panel) return;
    parts.panel.hidden = !open;
    parts.button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) placePreorderHelp(notice, parts.panel);
  }

  function togglePreorderHelp(notice, wasOpenBeforePointer) {
    if (wasOpenBeforePointer === undefined) {
      setPreorderHelpOpen(notice, !isPreorderHelpOpen(notice));
      return;
    }
    setPreorderHelpOpen(notice, !wasOpenBeforePointer);
  }

  function closePreorderHelpOutside(target) {
    var notices = global.document.querySelectorAll(PREORDER_HELP_SELECTOR);
    for (var index = 0; index < notices.length; index += 1) {
      if (!notices[index].contains(target)) setPreorderHelpOpen(notices[index], false);
    }
  }

  function initPreorderHelp() {
    if (!global.document) return;
    global.document.addEventListener('pointerover', function (event) {
      var notice = event.target.closest && event.target.closest(PREORDER_HELP_SELECTOR);
      if (notice && event.pointerType !== 'touch') setPreorderHelpOpen(notice, true);
    }, true);
    global.document.addEventListener('pointerout', function (event) {
      var notice = event.target.closest && event.target.closest(PREORDER_HELP_SELECTOR);
      if (notice && event.pointerType !== 'touch' && (!event.relatedTarget || !notice.contains(event.relatedTarget))) setPreorderHelpOpen(notice, false);
    }, true);
    global.document.addEventListener('focusin', function (event) {
      var notice = event.target.closest && event.target.closest(PREORDER_HELP_SELECTOR);
      if (notice) {
        notice.__tfPreorderHelpOpenedByFocus = !isPreorderHelpOpen(notice);
        setPreorderHelpOpen(notice, true);
      }
    }, true);
    global.document.addEventListener('focusout', function (event) {
      var notice = event.target.closest && event.target.closest(PREORDER_HELP_SELECTOR);
      if (notice && (!event.relatedTarget || !notice.contains(event.relatedTarget))) setPreorderHelpOpen(notice, false);
    }, true);
    global.document.addEventListener('pointerdown', function (event) {
      var button = event.target.closest && event.target.closest('.cart-preorder-notice__help');
      var notice = button && button.closest(PREORDER_HELP_SELECTOR);
      if (notice) {
        notice.__tfPreorderHelpWasOpenBeforePointer = notice.__tfPreorderHelpOpenedByFocus ? false : isPreorderHelpOpen(notice);
        notice.__tfPreorderHelpOpenedByFocus = undefined;
      }
    }, true);
    global.document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('.cart-preorder-notice__help');
      var notice = button && button.closest(PREORDER_HELP_SELECTOR);
      if (notice) {
        if (notice.__tfPreorderHelpWasOpenBeforePointer === true) setPreorderHelpOpen(notice, false);
        else if (notice.__tfPreorderHelpWasOpenBeforePointer === false) setPreorderHelpOpen(notice, true);
        else if (notice.__tfPreorderHelpOpenedByFocus) setPreorderHelpOpen(notice, true);
        else if (event.detail === 0) togglePreorderHelp(notice);
        else setPreorderHelpOpen(notice, true);
        notice.__tfPreorderHelpWasOpenBeforePointer = undefined;
        notice.__tfPreorderHelpOpenedByFocus = undefined;
        return;
      }
      closePreorderHelpOutside(event.target);
    }, true);
    global.document.addEventListener('keydown', function (event) {
      var notices;
      if (event.key !== 'Escape') return;
      notices = global.document.querySelectorAll(PREORDER_HELP_SELECTOR);
      for (var index = 0; index < notices.length; index += 1) {
        if (!isPreorderHelpOpen(notices[index])) continue;
        setPreorderHelpOpen(notices[index], false);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
    }, true);
    if (global.addEventListener) global.addEventListener('resize', function () {
      var notices = global.document.querySelectorAll(PREORDER_HELP_SELECTOR);
      for (var index = 0; index < notices.length; index += 1) {
        var parts = preorderHelpParts(notices[index]);
        if (parts.panel && !parts.panel.hidden) placePreorderHelp(notices[index], parts.panel);
      }
    });
  }

  function init() {
    enhanceMultibuy();
    if (!global.document) return;
    global.document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(DISCLOSURE_SELECTOR);
      if (!button) return;
      event.preventDefault();
      toggleBundleDisclosure(button);
    });
    // Prestige dispatches this bubbling event after it has replaced the drawer
    // children, so enhancement always targets the fresh cart markup.
    global.document.addEventListener('cart-drawer:refreshed', enhanceMultibuy);
    initPreorderHelp();
  }

  global.TheFaithCartProductDisplay = {
    enhanceMultibuy: enhanceMultibuy,
    displayPieceLabel: displayPieceLabel,
    cartSurfaceFor: cartSurfaceFor,
    qualifyingPieceQuantity: qualifyingPieceQuantity,
    setPreorderHelpOpen: setPreorderHelpOpen,
    isPreorderHelpOpen: isPreorderHelpOpen,
    placePreorderHelp: placePreorderHelp,
    togglePreorderHelp: togglePreorderHelp,
    toggleBundleDisclosure: toggleBundleDisclosure
  };

  if (global.document && global.document.readyState === 'loading') global.document.addEventListener('DOMContentLoaded', init);
  else init();
})(typeof window !== 'undefined' ? window : globalThis);
